// @ts-nocheck
import * as React from "react";
import anime from "animejs/lib/anime.es.js";

// Components
import Loader from "../Loader";
import Banner from "../Banner";
import ModalInfo from "../modalInfo";

const THEMEURL = window.drupalSettings
  ? window.drupalSettings.path.themeUrl
  : "themes/custom/mx_aguas_firmes_theme";

const elementList = [
  <img
    className="af-bg-aditional__cloud"
    src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube1.png`}
    alt=""
    title=""
  />,
  <img
    className="af-bg-aditional__cloud2"
    src={`/${THEMEURL}/sources/dist/assets/images/general/background/cielo/nube3.png`}
    alt=""
    title=""
  />,
];

export const Login = ({ data, setLoading, loading }: any) => {
  const urlFlagResendEmail = new URL(location.href).searchParams.get(
    "resendEmail"
  );
  React.useEffect(() => {
    window.onload = function () {
      setLoading(false);
    };
  }, []);

  const animateSky = () => {
    anime({
      targets: ".af-bg-aditional__cloud",
      translateX: 100,
      loop: true,
      easing: "linear",
      direction: "alternate",
      duration: 20000,
    });

    anime({
      targets: ".af-bg-aditional__cloud2",
      translateX: -50,
      loop: true,
      easing: "linear",
      direction: "alternate",
      duration: 10000,
    });
  };

  React.useEffect(() => {
    animateSky();
  });

  return (
    <main>
      <ModalInfo
        title={"¡Correo reenviado!"}
        subtitle={"Revisa tu correo electrónico"}
        desc={"Te hemos enviado un correo para confirmar tu cuenta"}
        checkEmail={urlFlagResendEmail == "true"}
      />
      <div className="boxAllies">
        <Banner
          backImage={{
            desk: `/${THEMEURL}/sources/dist/assets/images/register/banner.jpg`,
            mobile: `/${THEMEURL}/sources/dist/assets/contact/contactoMobile.jpg`,
          }}
          textBanner={!loading ? data.field_title : ""}
          textDescription={data.field_desc}
          componentsAnimated={elementList}
          newBanner={1}
        />
      </div>
      <div className="background-contact">
        {/* <FishSec /> */}
        <div
          id="newFormLogin"
          className="form"
          data-aos="fade-up"
          data-aos-duration="1000"
          data-aos-anchor-placement="top-bottom"
        ></div>
      </div>
    </main>
  );
};

export default Loader(Login);
